import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generatePositions } from '../CallsheetUtils';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import { TYPE_SET } from '../../../constants/booking';
import CallsheetTable from './CallsheetTable';
import CallsheetSpecialProjectRow from './CallsheetSpecialProjectRow';
import NumberOfSetDoubleBookRow from './NumberOfSetDoubleBookRow';

class AccessoriesSheet extends Component {
  render() {
    const { info, name, renderForEmail, locationContacts } = this.props;
    return (
      <CallsheetTable
        name={name}
        callTime={info.callTime}
        wrapTime={info.wrapTime}
        locationContacts={locationContacts ? locationContacts[TYPE_SET] : i18n.t('noData')}
        renderForEmail={renderForEmail}
      >
        <NumberOfSetDoubleBookRow info={info} />
        <tr>
          <th style={styles.tableCell}>{i18n.t('location:acc')}</th>
          <th style={styles.tableCell}>{i18n.t('location:bag')}</th>
          <th colSpan="2" style={styles.tableCell}>{i18n.t('location:shoe')}</th>
        </tr>
        <tr>
          <td style={styles.tableCell}>{info.accCount}</td>
          <td style={styles.tableCell}>{info.bagCount}</td>
          <td colSpan="2" style={styles.tableCell}>{info.shoeCount}</td>
        </tr>
        <tr>
          <th style={styles.tableCell}>{i18n.t('location:pets')}</th>
          <th style={styles.tableCell}>{i18n.t('location:kids')}</th>
          <th style={styles.tableCell}>{i18n.t('location:homeTechActivityAbreviation')}</th>
          <th style={styles.tableCell}>{i18n.t('location:selfCareAbreviation')}</th>
        </tr>
        <tr>
          <td style={styles.tableCell}>{info.petsCount}</td>
          <td style={styles.tableCell}>{info.kidsCount}</td>
          <td style={styles.tableCell}>{info.homeTechActivityCount}</td>
          <td style={styles.tableCell}>{info.selfCareCount}</td>
        </tr>
        <tr>
          <th style={styles.tableCell} colSpan="2">
            {i18n.t('booking:setType')}
          </th>
          <th style={styles.tableCell} colSpan="2">
            {i18n.t('booking:percentage')}
          </th>
        </tr>
        <tr>
          <td style={styles.tableCell} colSpan="2">
            {info.setType}
          </td>
          <td style={styles.tableCell} colSpan="2">
            {`${info.percentage} %`}
          </td>
        </tr>
        <CallsheetSpecialProjectRow
          specialProject={info.specialProject}
        />
        {generatePositions(info)}
      </CallsheetTable>
    );
  }
}

AccessoriesSheet.propTypes = {
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ),
  name: PropTypes.string.isRequired,
  info: PropTypes.shape({
    callTime: PropTypes.string.isRequired,
    wrapTime: PropTypes.string.isRequired,
    numberOfSet: PropTypes.string.isRequired,
    isDoubleStylist: PropTypes.bool.isRequired,
    accCount: PropTypes.number.isRequired,
    bagCount: PropTypes.number.isRequired,
    shoeCount: PropTypes.number.isRequired,
    petsCount: PropTypes.number.isRequired,
    kidsCount: PropTypes.number.isRequired,
    homeTechActivityCount: PropTypes.number.isRequired,
    selfCareCount: PropTypes.number.isRequired,
    setType: PropTypes.string.isRequired,
    percentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
    specialProject: PropTypes.shape({
      name: PropTypes.string.isRequired,
      notes: PropTypes.string.isRequired
    }),
    positions: PropTypes.objectOf(
      PropTypes.shape({
        employees: PropTypes.arrayOf(
          PropTypes.shape({ email: PropTypes.string, name: PropTypes.string })
        )
      })
    ).isRequired
  }).isRequired,
  renderForEmail: PropTypes.bool.isRequired
};

AccessoriesSheet.defaultProps = {
  locationContacts: null,
};

export default AccessoriesSheet;
